module.exports = __webpack_public_path__ + "static/img/a079.913e1c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a079.jpg
// module id = /Eag
// module chunks = 0